import { render, staticRenderFns } from "./RegionNavigation.vue?vue&type=template&id=5e3a50ba&"
import script from "./RegionNavigation.vue?vue&type=script&lang=js&"
export * from "./RegionNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports